import {useStickyHeaderContentArea} from '@defign/ui'

import {Header, LeftLinkButton, RightSettingButton} from '$components/common/header'
import {INTERNAL_ROUTES} from '$constants/internal-routes'

import type {MutuallyExclusive} from '$types/utility-types'

export default function InsuranceMyHeader({
    title = '',
    backNClickCode,
    ...props
}: MutuallyExclusive<
    {
        title?: string
        assetId: number
        hideManagementButton: false
        backNClickCode: string
        managementNClickCode: string
    },
    {
        title?: string
        hideManagementButton: true
        backNClickCode: string
    }
>) {
    const {isFixed} = useStickyHeaderContentArea()

    return (
        <Header title={isFixed ? title : ''} forceBackgroundWhite>
            <LeftLinkButton text="홈" href={INTERNAL_ROUTES.INSURANCE_MY_HOME} nClickCode={backNClickCode} />
            {!props.hideManagementButton && (
                <RightSettingButton nClickCode={props.managementNClickCode} id={props.assetId} />
            )}
        </Header>
    )
}
